import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { FiX, FiGift } from 'react-icons/fi';

const DiscountPopup = ({ lang }) => {
  const [offerStage, setOfferStage] = useState(0); // 0: hidden, 1: 10%, 2: 20%
  const [hasClosed, setHasClosed] = useState(false);

  useEffect(() => {
    if (hasClosed) return;

    // Show 10% offer after 30 seconds
    const timer1 = setTimeout(() => {
      setOfferStage(1);
    }, 30000);

    // Show 20% offer after 60 seconds (30s after first popup logic implies increasing urgency)
    const timer2 = setTimeout(() => {
      setOfferStage(2);
    }, 60000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [hasClosed]);

  if (offerStage === 0 || hasClosed) return null;

  const discount = offerStage === 1 ? '10%' : '20%';
  const code = offerStage === 1 ? 'WELCOME10' : 'LASTCHANCE20';
  
  const titleEn = offerStage === 1 ? "Wait! Get 10% Off" : "Final Offer! 20% Off";
  const titleEs = offerStage === 1 ? "¡Espera! 10% Descuento" : "¡Oferta Final! 20% Descuento";
  
  const textEn = offerStage === 1 ? "Book your first appointment today and save." : "Don't miss out. This offer expires soon!";
  const textEs = offerStage === 1 ? "Reserva tu primera cita hoy y ahorra." : "No te lo pierdas. ¡Esta oferta expira pronto!";

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0, scale: 0.9, y: 50 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-32 md:w-96 z-[9999] bg-black border-2 border-mx-gold rounded-2xl shadow-2xl p-6"
      >
        <button 
          onClick={() => setHasClosed(true)} 
          className="absolute top-2 right-2 text-gray-400 hover:text-white"
        >
          <FiX size={20} />
        </button>

        <div className="flex items-start gap-4">
          <div className="bg-mx-red p-3 rounded-full text-white animate-pulse">
            <FiGift size={24} />
          </div>
          <div>
            <div className="text-mx-gold font-bold text-xs uppercase tracking-widest mb-1">
              {lang === 'es' ? 'Oferta Especial' : 'Special Offer'}
            </div>
            <h3 className="text-white font-black text-2xl mb-2">{lang === 'es' ? titleEs : titleEn}</h3>
            <p className="text-gray-300 text-sm mb-4">{lang === 'es' ? textEs : textEn}</p>
            
            <a 
              href={`https://wa.me/529841771113?text=I want to claim my ${discount} discount code: ${code}`}
              target="_blank" 
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-mx-green text-white px-6 py-3 rounded-xl font-bold hover:bg-white hover:text-mx-green transition-all w-full justify-center shadow-lg"
            >
              <FaWhatsapp className="text-xl" />
              {lang === 'es' ? 'Reclamar Descuento' : 'Claim Discount'}
            </a>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DiscountPopup;